module.exports = __webpack_public_path__ + "img/book-004.31fbfee6.png";